import React, { useState } from "react"
import Fade from "react-reveal/Fade"
import { useTranslation } from "react-i18next";
import QuestionAnswer from "./QuestionAnswer"

const FAQ = ({marginTop, view}) => {
	
	const [expanded, setExpanded] = useState(false);
	const {t} = useTranslation();
	
	const toggleQuestion = () => {
		setExpanded(!expanded);
	};
	
	const faq = [
		// {
		// 	id: 1,
		// 	question: 'Tôi vẫn chưa hiểu rõ website đám cưới là gì, có gì đặc biệt ?',
		// 	answer: `Trong thời đại 4.0, việc có một website đám cưới để chia sẻ và lưu giữ những khoảnh khắc ngọt ngào của tình yêu, của ngày hôn nhân trọng đại là điều rất quan trọng và thời thượng.
		// 			Trang web thể hiện được đầy đủ thông tin về đám cưới, dâu, rể, nơi tổ chức sự kiện, cũng như kể lại hành trình gặp gỡ và yêu nhau của cả hai, giúp cho câu chuyện thêm phần ý nghĩa và lung linh.
		// 			Đặc biêt, trang web mời cưới online còn thể hiện một sự tôn trọng và lịch thiệp đối với những người bạn ở xa, không thể trao tận tay thiệp cứng.`,
		// 	views: ['home', 'about-us']
		// },
		// {
		// 	id: 2,
		// 	question: 'Tôi muốn tự thiết kế một trang cưới mang đậm dấu ấn cá nhân được không ?',
		// 	answer: `Hoàn toàn được nhé, Let's Celebrate cung cấp một bộ công cụ giúp người dùng có thể linh động trong việc tùy chỉnh, thiết kế theo ý thích của mình. Bạn hoàn toàn
		// 			có thể dùng mẫu có sẵn rồi thêm những thành phần mà bạn muốn vào trang`,
		// 	views: ['wedding-template']
		// },
		// {
		// 	id: 3,
		// 	question: 'Tôi có thể tạo được nhiều trang web với những mục đích khác được không ?',
		// 	answer: `Đương nhiên rồi, không chỉ là thiệp cưới, mà với bộ tính năng cho phép tùy chỉnh một cách thoải mái của Let's Celebrate, bạn hoàn toàn có thể tự tạo cho mình một
		// 	trang với những mục đích khác như lễ kỉ niệm một năm tình yêu, đếm ngày yêu hay lễ sinh nhật, lễ tết. Tất cả hoàn toàn nằm ở trí sáng tạo của các bạn. Ngoài ra, chính Let's Celebrate
		// 	sẽ sớm đưa ra những template khác với những ngày lễ khác nhau, phục vụ cho nhu cầu đa dạng của khách hàng.`,
		// 	views: ['wedding-template']
		// },
		// {
		// 	id: 4,
		// 	question: 'Tôi có được đặt tên miền một cách tự do không ?',
		// 	answer: `Có nha, chỉ cần tên miền của bạn chưa trùng với bất cứ tên miền của một đám cưới khác thì bạn có thể lấy tên đó nhé. Một lưu ý nhỏ là tên miền không
		// 				được có dấu tiếng việt và nên đặt những tên dễ hiểu thôi nha.`,
		// 	views: ['wedding-template']
		// },
		// {
		// 	id: 5,
		// 	question: `Let's Celebrate là một nền tảng toàn diện cho đám cưới nhưng tôi mới chỉ thấy phục vụ mỗi thiệp cưới online ?`,
		// 	answer: `Đúng vậy, chúng tôi là tập hợp các bạn trẻ có đam mê, khát khao mang lại một sản phẩm toàn diện để giúp cho mọi người chuẩn bị đám cưới thật tốt. Ở phiên bản
		// 			đầu tiên, Let's Celebrate phục vụ quý khách với bộ công cụ thiết kế trang mời cưới tốt nhất trên thị trường. Hãy đón chờ những phiên bản tiếp theo của chúng tôi nhé.`,
		// 	views: ['home', 'about-us']
		// },
		// {
		// 	id: 6,
		// 	question: "Chi phí sử dụng Let's Celebrate là bao nhiêu?",
		// 	answer: `Let's Celebrate cung cấp nhiều gói dịch vụ linh hoạt để phù hợp với nhu cầu của bạn. Bạn có thể bắt đầu với gói miễn phí để tạo thiệp cưới cơ bản. Các gói cao cấp hơn, bao gồm các tính năng nâng cao và tùy chỉnh, có giá từ 1.000.000 VND đến 5.000.000 VND.`,
		// 	views: ['home', 'pricing', 'about-us']
		// },
		// {
		// 	id: 7,
		// 	question: "Làm thế nào để bắt đầu sử dụng Let's Celebrate?",
		// 	answer: `Để bắt đầu, bạn chỉ cần đăng ký tài khoản trên trang web của chúng tôi. Sau khi đăng nhập, bạn sẽ được hướng dẫn từng bước để tạo và tùy chỉnh trang web cưới của mình. Chúng tôi có các video hướng dẫn và hỗ trợ trực tuyến để giúp bạn trong suốt quá trình.`,
		// 	views: ['home', 'how-to-use', 'getting-started']
		// },
		// {
		// 	id: 8,
		// 	question: "Let's Celebrate có hỗ trợ khách hàng không?",
		// 	answer: `Chắc chắn rồi! Let's Celebrate cung cấp dịch vụ hỗ trợ khách hàng qua email và chat trực tuyến hàng ngày. Đội ngũ của chúng tôi luôn sẵn sàng giải đáp mọi thắc mắc và hỗ trợ bạn kịp thời.`,
		// 	views: ['home', 'support', 'contact-us']
		// },
		// {
		// 	id: 9,
		// 	question: 'Tôi có thể chỉnh sửa trang web cưới sau khi đã tạo không?',
		// 	answer: `Hoàn toàn có thể. Let's Celebrate cho phép bạn chỉnh sửa và cập nhật trang web cưới của mình bất cứ lúc nào. Bạn chỉ cần đăng nhập vào tài khoản và thực hiện các thay đổi mà bạn muốn.`,
		// 	views: ['wedding-template', 'how-to-use']
		// },
		// {
		// 	id: 10,
		// 	question: "Let's Celebrate có những tính năng nào giúp tiết kiệm thời gian?",
		// 	answer: `Let's Celebrate cung cấp các công cụ tự động hóa như quản lý danh sách khách mời, gửi thiệp mời tự động, và theo dõi phản hồi RSVP. Những tính năng này giúp bạn tiết kiệm thời gian đáng kể trong quá trình chuẩn bị đám cưới.`,
		// 	views: ['home', 'features', 'time-saving']
		// }
		
		{
			id: 1,
			question: 'Công cụ này có dễ sử dụng không?',
			answer: `Sản phẩm của chúng tôi được thiết kế thân thiện với người dùng và dễ dàng sử dụng cho các cặp đôi có mức độ am hiểu công nghệ khác nhau. Website có giao diện trực quan và hướng dẫn rõ ràng.`,
			views: ['home', 'about-us', 'wedding-template']
		},
		{
			id: 1,
			question: `Chi phí sử dụng Let's Celebrate là bao nhiêu?`,
			answer: `Let's Celebrate cung cấp nhiều gói dịch vụ linh hoạt để phù hợp với nhu cầu của bạn. Bạn có thể bắt đầu với gói miễn phí để tạo thiệp cưới cơ bản. Các gói cao cấp hơn, bao gồm các tính năng nâng cao và tùy chỉnh, có giá từ 300.000 VND đến 1.000.000 VND.`,
			views: ['home', 'about-us', 'wedding-template']
		},
		{
			id: 1,
			question: "Let's Celebrate có hỗ trợ khách hàng không?",
			answer: `Chắc chắn rồi! Let's Celebrate cung cấp dịch vụ hỗ trợ khách hàng qua email và chat trực tuyến hàng ngày. Đội ngũ của chúng tôi luôn sẵn sàng giải đáp mọi thắc mắc và hỗ trợ bạn kịp thời.`,
			views: ['home', 'about-us', 'wedding-template']
		},
		{
			id: 1,
			question: 'Có  danh sách các hạng mục chi tiêu mẫu để sử dụng hay không?',
			answer: `Có. Phần mềm của chúng tôi sẽ đưa ra gợi ý chi tiêu phù hợp dựa trên quy mô và chi phí dự trù bạn đưa ra.`,
			views: ['home', 'about-us', 'wedding-template']
		},
		{
			id: 1,
			question: 'Công cụ có cho phép tạo danh sách việc cần làm cho đám cưới hay không?',
			answer: `Tất nhiên rồi. Công cụ của chúng tôi có các tính năng quản lí công việc, tạo, sửa, xóa, đặt deadline cho các đầu việc để đảm bảo không có việc gì bị chậm trễ. Ngoài ra còn có các dữ liệu mẫu giúp cho cô dâu chú rể có thể hình dung một cách tổng quan những công việc có trong đám cưới và các mốc thời gian quan trọng`,
			views: ['home', 'about-us', 'wedding-template']
		},
		
	];
	
	return <>
		<div className={`max-w-4xl mx-auto ${marginTop} mb-20 text-center text-black`}>
			<Fade>
				<div>
					<h3
						className=" text-redTextTitle font-bold text-2xl xxs:text-2xl xs:text-2xl sm:text-lg md:text-2xl lg:text-4xl xl:text-2xl 2xl:text-4xl flex justify-center text-center">
						{t('Giúp bạn trả lời những câu hỏi ?')}
					</h3>
				</div>
			</Fade>
			
			<Fade bottom cascade>
				<div className="grid grid-cols-1 gap-2C text-left mt-10 xxs:grid-cols-1 sm:grid-cols-1">
					{faq.map((f) => {
						if(!f.views.includes(view)) {
							return null;
						}
						
						return <QuestionAnswer
							question={t(f.question)}
							answer={t(f.answer)}
						/>
					})}
				</div>
			</Fade>
		</div>
	</>
}

FAQ.defaultProps = {
	marginTop: 'mt-20',
	view: 'home'
}

export default FAQ
